import { colors } from './tokens';

const palette = {
  mode: 'light',
  primary: {
    main: colors.primary.main,
    dark: colors.primary.dark,
    contrastText: colors.primary.contrastText,
  },
  secondary: {
    main: colors.secondary.main,
    light: colors.secondary.light,
    dark: colors.secondary.dark,
    contrastText: colors.secondary.contrastText,
  },
  success: {
    main: colors.secondary.main,
    light: colors.secondary.light,
    dark: colors.secondary.dark,
    contrastText: colors.secondary.contrastText,
  },
  error: {
    main: colors.error.main,
    light: colors.error.light,
    dark: colors.error.dark,
    secondary: colors.error.secondary
  },
  warning: {
    main: '#F59E0B',
    light: '#FDE68A',
    dark: '#B45309',
    contrastText: colors.primary.contrastText,
  },
  text: {
    primary: colors.text.primary,
    secondary: colors.text.secondary,
    tertiary: colors.text.tertiary,
    disabled: colors.text.disabled,
  },
  background: {
    default: colors.background.default,
    paper: colors.background.paper,
    elevated: colors.background.elevated,
  },
  divider: colors.border.default,
  /** Custom nav palette group for sidebar active states */
  nav: {
    activeBackground: colors.nav.activeBackground,
    activeBorder: colors.nav.activeBorder,
    labelColor: colors.nav.labelColor,
  },
  // Legacy custom keys — required for color="Tertiary" etc. on existing pages
  Tertiary: colors.legacy.Tertiary,
  Errors: colors.legacy.Errors,
  Bg_color: colors.legacy.Bg_color,
  Title_Text_color: colors.legacy.Title_Text_color,
  White_color: colors.legacy.White_color,
  Heading_color: colors.legacy.Heading_color,
  Grey: colors.legacy.Grey,
};

export default palette;

export const status = {
  danger: colors.status.danger,
};

